import { render, staticRenderFns } from "./PosicionStockVentas.vue?vue&type=template&id=ee808f20"
import script from "./PosicionStockVentas.vue?vue&type=script&lang=ts"
export * from "./PosicionStockVentas.vue?vue&type=script&lang=ts"
import style0 from "./PosicionStockVentas.vue?vue&type=style&index=0&id=ee808f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports